<template>
  <div class="top-banner">
    <div class="banner-content">
      <slot name="text" />
    </div>
    <div class="banner-buttons">
      <slot name="buttons" />
    </div>
  </div>
</template>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.top-banner {
  .ds1-pa-2();
  background-color: @DS2-UTD-BANNER-BG-COLOR;
  box-shadow: @DS1-BOX-SHADOW;
  box-sizing: border-box;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  flex-wrap: wrap;
  z-index: 99999999;
}

.banner-buttons {
  display: flex;
  gap: 8px;
}
</style>
